<template>
  <div class="btn-group-list-content" :ref="($event) => setRef($event)">
    <jw-popover trigger="click" position="bottom" :popup-container="props.popupContainer" class="btn-popover-popover" :style="getStyle" @popup-visible-change="popChange">
      <jw-button size="small" type="text" :class="['add-btn', data.visibility ? 'select-btn' : '']">
        <template #icon><qfei-icon-add-two-outlined class="add-btn-icon" /></template>{{ title }}</jw-button
      >
      <template #content>
        <select-list :list="data.btnGroup?.allModules" :check-ids="data.btnGroup?.setChecked" @cb="getCheckedIds" :empty="true" :isonIsShow="false" />
      </template>
    </jw-popover>
    <btn-list :list="data.btnGroup" @cb="updateBtn" :freeze="false" :sort="props.sort" />
  </div>
</template>

<script setup>
import { reactive, watchEffect, inject, computed } from 'vue';
import _ from 'lodash';
import { QfeiIconAddTwoOutlined } from '@qfei-design/icons-vue';
import BtnList from '@/views/setting/sys-fields/page-layout/components/btn-list/btn-list.vue'; //按钮列表
import SelectList from '@/views/setting/sys-fields/page-layout/components/select-field/select-field.vue'; //选择按钮
const emits = defineEmits(['cb']);
const props = defineProps({
  list: {
    // 全部数据
    type: Object,
    default: () => {}
  },
  type: {
    type: Number || String,
    default: 150 //150:通用按钮 160:批量操作按钮 170:快捷操作按钮
  },
  title: {
    type: String,
    default: '添加按钮'
  },
  popupContainer: {
    //挂载容器
    type: String,
    default: '.btn-group-list-content'
  },
  sort: {
    //是否支持排序
    type: Boolean,
    default: true
  },
  btnGroupIndex: {
    //按钮组的索引
    type: Number || String,
    default: 0
  },
  source: {
    type: String,
    default: ''
  },
  positionLeft: {
    type: Number || String,
    default: 16
  }
});
const position = reactive({
  150: {
    top: 0,
    left: 16
  },
  160: {
    top: 0,
    left: 16
  },
  170: {
    top: 0,
    left: 16
  }
});
const getStyle = computed(() => {
  if (props.source == 'view') {
    return { left: '8px' };
  }
  return { top: `${position[props.type].top}px`, left: `${props.positionLeft}px` };
});
const btnDataRefs = reactive({});
const setRef = (e) => {
  btnDataRefs[`btnRef${props.type}`] = e;
};

const data = reactive({
  btnGroup: {}, //所有按钮数据
  visibility: false
});
watchEffect(() => {
  data.btnGroup = props.list;
});
const getParentData = inject('parentData'); //调用父组件数据
const provideMethds = inject('provideMethds'); //调用父组件方法
const getParentRect =
  getParentData?.getParentRect ||
  (() => {
    return '';
  });
const getParentModalRect =
  provideMethds?.getParentModalRect ||
  (() => {
    return '';
  });
const popChange = (e) => {
  data.visibility = e;
  const getParentRectData = provideMethds?.getParentModalRect ? getParentModalRect() : getParentRect();
  if (btnDataRefs?.[`btnRef${props.type}`]) {
    const rect = btnDataRefs?.[`btnRef${props.type}`]?.getBoundingClientRect();
    if (provideMethds?.getParentModalRect) {
      position[props.type].top = rect.top - getParentRectData.parentTop + getParentRectData?.scrollTop - 21;
    } else {
      position[props.type].top = rect.top + getParentRectData?.scrollTop - 21;
    }
  }
};
const getCheckedIds = (getModules) => {
  const modules = data.btnGroup?.modules;
  if (!Array.isArray(modules)) return;
  modules.forEach((el) => {
    const findfield = getModules?.modules?.find((mo) => mo.settingId == el.settingId);
    if (findfield) {
      el.showField = findfield.showField;
    }
  });
  const getFields = _.cloneDeep(modules);

  data.btnGroup.setChecked = [];

  getFields?.forEach((el) => {
    if (el?.showField) {
      //显示
      data.btnGroup.setChecked.push(el.settingId);
    }
  });
  //抛出数据
  emits('cb', { data: data.btnGroup, type: props.type, index: props.btnGroupIndex });
};
const updateBtn = (getModules) => {
  data.btnGroup = getModules;
  const getFields = _.cloneDeep(data.btnGroup?.modules);

  data.btnGroup.setChecked = [];

  getFields?.forEach((el) => {
    if (el?.showField) {
      //显示
      data.btnGroup.setChecked.push(el.settingId);
    }
  });
  //抛出数据
  emits('cb', { data: data.btnGroup, type: props.type, index: props.btnGroupIndex });
  // console.log('getModules------', getModules);
};
</script>

<style scoped lang="less">
@import './btn-group.less';
</style>
